import * as angular from 'angular';
import * as _ from 'lodash';

import { VideoService } from '../core/services/video-service';

interface IHomeScope extends angular.IScope {
    playVideo: (title: string, src: string) => void;
}

export class HomeController implements angular.IController {
    static readonly $inject = ['$scope', 'fcVideoService'];

    constructor(private readonly scope: IHomeScope, private readonly videoService: VideoService) {
        this.scope.playVideo = this.playVideo.bind(this);
    }

    private playVideo(title: string, src: string): void {
        this.videoService.playVideo(title, src);
    }
}
